import { Dispatch, ThunkAction } from './../../../../../types/actions';
import { showSnoozeBlocker } from '../../../base/effects/showSnoozeBlocker';

export const checkTabTimingPermission = (
): ThunkAction => {
    const action = (
        dispatch: Dispatch
    ) => {
        dispatch(showSnoozeBlocker({
            allow: 'allowTimeTracker'
        }));
    };
    return action;
};
